// ── Perspective scaling — character size by depth on a 2D scene ─────────────
//
// Used by scenes (title card, future overworld zones) that fake depth via
// Y-position. Given a normalized Y on the scene (0 = top, 1 = bottom), we
// return a sprite scale that shrinks toward a horizon line.
//
// The curve is non-linear by default (>1) so things shrink fast near the
// horizon — matching how a camera with a moderate FOV behaves.
/**
 * Compute a perspective scale for a sprite at normalized scene Y.
 * Clamped to [minScale, maxScale]; returns maxScale when the profile is
 * degenerate (horizonY === nearY).
 */
export function perspectiveScale(ny, profile) {
    const { horizonY, nearY, minScale, maxScale } = profile;
    const curve = profile.curve ?? 1.5;
    if (nearY === horizonY)
        return maxScale;
    const raw = (ny - horizonY) / (nearY - horizonY);
    const t = Math.max(0, Math.min(1, raw));
    const eased = Math.pow(t, curve);
    return minScale + (maxScale - minScale) * eased;
}
//# sourceMappingURL=perspective.js.map